import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/arrow-up.png'
import _imports_1 from '@/assets/images/arrow-down.png'


const _withScopeId = n => (_pushScopeId("data-v-1d2c61b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  src: _imports_0,
  style: {"width":"20px"}
}
const _hoisted_2 = {
  key: 1,
  src: _imports_1,
  style: {"width":"20px"}
}




export default /*#__PURE__*/_defineComponent({
  __name: 'ArrowDownUp',
  props: {
  isUp: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["arrow-down",  props.isUp ? 'blinking-up' : 'blinking-down' ])
  }, [
    (props.isUp)
      ? (_openBlock(), _createElementBlock("img", _hoisted_1))
      : (_openBlock(), _createElementBlock("img", _hoisted_2))
  ], 2))
}
}

})